var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFruits(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 500,
    height: 500,
    viewBox: "0 0 500 500",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_20280_301217)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M500 0H0V500H500V0Z",
    fill: "#B1B6EF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.9 318C416.7 333.2 416.7 357.9 431.9 373L500 441.1V500H0V206.7C14.4 213.5 32.1 210.9 44 199L243 0H359L500 141.1V250L431.9 318Z",
    fill: "#BAC2F7"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.08,
    d: "M256.2 418.4C329.488 418.4 388.9 408.237 388.9 395.7C388.9 383.163 329.488 373 256.2 373C182.912 373 123.5 383.163 123.5 395.7C123.5 408.237 182.912 418.4 256.2 418.4Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.9 328.9C324.349 328.9 369.3 288.292 369.3 238.2C369.3 188.108 324.349 147.5 268.9 147.5C213.451 147.5 168.5 188.108 168.5 238.2C168.5 288.292 213.451 328.9 268.9 328.9Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.9 350.7C286.9 350.9 286.8 351.1 286.8 351.3C286 354.7 283.1 359.1 277.5 364.9C277.1 365.3 276.7 365.7 276.4 366.1C274.4 368.1 272.3 370.1 270.3 371.9C245.2 393.8 190 417.7 123.1 357.8C103.9 340.6 95.6 315.2 89.5 294.1C82.5 270.1 84.5 245.4 98.4 223C101.1 218.6 104.3 214.3 107.9 210.1C109.5 208.3 111.2 206.4 112.9 204.6C113.2 204.3 113.4 204.1 113.7 203.8C114 203.5 114.4 203.1 114.7 202.8C117.3 200.3 119.7 198.3 121.7 196.8C122.4 196.3 123 195.9 123.7 195.5C125.9 194.2 127.8 193.6 129.4 193.6C131.1 193.6 132.5 194.2 133.6 195.3C145.8 207.1 134.5 277.4 168.8 311.4C201.7 343.8 267.2 334.1 283.4 343.7C286.1 345.5 287.4 347.7 286.9 350.7Z",
    fill: "#FFDE17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.9 204.7C112.9 204.7 121.7 193.6 124.7 186.5C127.7 179.4 121.4 168.8 121.4 168.8C121.4 168.8 132.4 159.7 138 164C148.4 172.1 145.5 179.6 145.5 179.6C145.5 179.6 133.4 186.9 136.1 191.7C139.4 197.7 139 210.4 139 210.4C139 210.4 136.3 199.4 125.9 198.8C121.9 198.5 112.9 204.7 112.9 204.7Z",
    fill: "#544B25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.6 341.2C275.6 341.2 273.5 346.5 271.5 351.2C269.5 355.9 276.5 361.5 282.8 358.9C289.1 356.3 292.5 342.6 287.7 339C282.9 335.4 275.6 341.2 275.6 341.2Z",
    fill: "#544B25"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M283.3 343.9L271.4 351.2C271.4 351.2 227.5 367.2 185 363.6C142.6 360 129.1 290.3 117.7 262.3C106.3 234.3 125.7 198.7 125.7 198.7L133.5 195.5C145.7 207.3 134.4 277.6 168.7 311.6C201.6 344 267.2 334.2 283.3 343.9Z",
    fill: "#544B25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.153 203.107C253.177 201.973 252.564 197.031 249.784 192.067C247.004 187.104 243.11 184 241.086 185.133C239.062 186.267 239.675 191.209 242.455 196.173C245.235 201.136 249.129 204.24 251.153 203.107Z",
    fill: "#158743"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.24 205.394C268.795 203.142 264.768 200.212 259.245 198.85C253.722 197.488 248.795 198.21 248.24 200.462C247.684 202.714 251.711 205.644 257.234 207.006C262.757 208.368 267.685 207.646 268.24 205.394Z",
    fill: "#158743"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.7 220C258.4 229.4 243.6 241.5 234.1 237.2C224.7 232.9 224.2 213.7 228.5 204.3C232.8 194.9 241.4 195.2 250.8 199.5C260.2 203.8 267.1 210.5 262.7 220Z",
    fill: "#C04F29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.5 205.9C237.494 205.9 238.3 205.094 238.3 204.1C238.3 203.106 237.494 202.3 236.5 202.3C235.506 202.3 234.7 203.106 234.7 204.1C234.7 205.094 235.506 205.9 236.5 205.9Z",
    fill: "#E29B88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.4 216.5C256.394 216.5 257.2 215.694 257.2 214.7C257.2 213.706 256.394 212.9 255.4 212.9C254.406 212.9 253.6 213.706 253.6 214.7C253.6 215.694 254.406 216.5 255.4 216.5Z",
    fill: "#E29B88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.1 217.7C237.094 217.7 237.9 216.894 237.9 215.9C237.9 214.906 237.094 214.1 236.1 214.1C235.106 214.1 234.3 214.906 234.3 215.9C234.3 216.894 235.106 217.7 236.1 217.7Z",
    fill: "#E29B88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.6 210.6C247.594 210.6 248.4 209.794 248.4 208.8C248.4 207.806 247.594 207 246.6 207C245.606 207 244.8 207.806 244.8 208.8C244.8 209.794 245.606 210.6 246.6 210.6Z",
    fill: "#E29B88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.9 229.2C249.894 229.2 250.7 228.394 250.7 227.4C250.7 226.406 249.894 225.6 248.9 225.6C247.906 225.6 247.1 226.406 247.1 227.4C247.1 228.394 247.906 229.2 248.9 229.2Z",
    fill: "#E29B88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.3 227C238.294 227 239.1 226.194 239.1 225.2C239.1 224.206 238.294 223.4 237.3 223.4C236.306 223.4 235.5 224.206 235.5 225.2C235.5 226.194 236.306 227 237.3 227Z",
    fill: "#E29B88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.9 199.5L257.4 190L261.4 192.8L251.9 200L250.9 199.5Z",
    fill: "#17964A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293 248.7C296.7 248.7 299.7 245.7 299.7 242C299.7 238.3 296.7 235.3 293 235.3C289.3 235.3 286.3 238.3 286.3 242C286.3 245.7 289.3 248.7 293 248.7Z",
    fill: "#131A46"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M295.4 241.2C296.228 241.2 296.9 240.528 296.9 239.7C296.9 238.872 296.228 238.2 295.4 238.2C294.572 238.2 293.9 238.872 293.9 239.7C293.9 240.528 294.572 241.2 295.4 241.2Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.3 256.5C176.768 256.5 181.2 252.068 181.2 246.6C181.2 241.132 176.768 236.7 171.3 236.7C165.832 236.7 161.4 241.132 161.4 246.6C161.4 252.068 165.832 256.5 171.3 256.5Z",
    fill: "#C04F29"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M176.6 244.9C177.594 244.9 178.4 244.094 178.4 243.1C178.4 242.106 177.594 241.3 176.6 241.3C175.606 241.3 174.8 242.106 174.8 243.1C174.8 244.094 175.606 244.9 176.6 244.9Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.8 293.6C312.268 293.6 316.7 289.168 316.7 283.7C316.7 278.232 312.268 273.8 306.8 273.8C301.332 273.8 296.9 278.232 296.9 283.7C296.9 289.168 301.332 293.6 306.8 293.6Z",
    fill: "#C04F29"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M312.1 282C313.094 282 313.9 281.194 313.9 280.2C313.9 279.206 313.094 278.4 312.1 278.4C311.106 278.4 310.3 279.206 310.3 280.2C310.3 281.194 311.106 282 312.1 282Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.5 122.6C300.9 92.1 209.3 113.4 176.3 162.1C174.4 164.9 172.8 168.1 171.4 171.2C171.1 172 170.3 174 170 174.8C169.8 175.6 169.2 177.7 168.9 178.5C158.9 221.7 212.8 249.2 246.1 262.3C246.7 262.5 247 263.2 246.7 263.8C246.5 264.4 245.8 264.7 245.2 264.4C218.4 254.1 190.2 241.4 172.7 217.6C170.3 214.3 168.2 210.4 166.5 206.6C166.2 205.8 165.3 203.5 165 202.6C164.2 200 163.5 197 163.1 194.3C162.1 186.8 162.9 179 165.4 171.8C167.5 165.6 170.7 159.7 174.5 154.4C204.4 114.7 265.2 95.1 313.6 100.4C328.4 102.1 343.2 106.3 356.5 113.7C362.3 117.3 357.5 125.8 351.5 122.6Z",
    fill: "#FFE600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.9 165C262.632 165 268.9 158.732 268.9 151C268.9 143.268 262.632 137 254.9 137C247.168 137 240.9 143.268 240.9 151C240.9 158.732 247.168 165 254.9 165Z",
    fill: "#C04F29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.7 241C360.9 234 369.4 224.6 376.1 215C395.9 186.2 391.9 159.1 367 135.5C362.2 130.9 357 126.6 351.4 122.7C346.3 118.9 350.8 111 356.7 113.6C369.2 119.4 381.6 126.9 391.6 136.5C418.7 162.1 420.8 198.1 406.2 231C399.9 245.4 391.6 258.6 381.5 270.4C373.5 279.7 358.7 279.7 350.5 270.7C342.6 262.2 343.2 248.9 351.7 241Z",
    fill: "#FFE600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.3 149.9C382.5 173.2 373 208.7 349.1 213.5C332.2 235.7 298 224.7 283.8 201.3C262.9 166.9 290.2 153.1 304.3 147C324.4 122.3 354.1 126.5 368.3 149.9Z",
    fill: "#1DB55D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.5 157.4C348.581 157.4 352.7 153.281 352.7 148.2C352.7 143.119 348.581 139 343.5 139C338.419 139 334.3 143.119 334.3 148.2C334.3 153.281 338.419 157.4 343.5 157.4Z",
    fill: "#69D193"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.5 152.4C308.5 152.4 299.8 140 293.3 137C291.9 136.4 296.9 132.9 298.5 133.1C304 133.9 310.6 151.5 310.6 151.5L308.5 152.4Z",
    fill: "#0C4C26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.4 99.9C307.4 99.9 316.1 110.1 314.6 120.9C313.1 131.8 307.5 140 302 139.2C296.5 138.4 293.3 129 294.8 118.2C296.3 107.4 307.4 99.9 307.4 99.9Z",
    fill: "#158743"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.828 136.563C185.048 133.533 179.197 130.639 171.761 130.1C164.324 129.56 158.118 131.579 157.898 134.609C157.678 137.638 163.528 140.532 170.965 141.071C178.401 141.611 184.608 139.592 184.828 136.563Z",
    fill: "#158743"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.5 132.644C198.976 127.584 201.743 121.674 199.682 119.443C197.62 117.212 191.51 119.506 186.035 124.566C180.559 129.626 177.791 135.537 179.853 137.768C181.915 139.999 188.025 137.705 193.5 132.644Z",
    fill: "#158743"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.6 136.1C218.8 147.7 221.4 172.6 209.8 179.8C198.2 187 177 173.7 169.8 162.2C162.6 150.7 169.2 141.5 180.7 134.3C192.2 127.1 204.4 124.5 211.6 136.1Z",
    fill: "#C04F29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.3 155.7C176.57 155.7 177.6 154.67 177.6 153.4C177.6 152.13 176.57 151.1 175.3 151.1C174.03 151.1 173 152.13 173 153.4C173 154.67 174.03 155.7 175.3 155.7Z",
    fill: "#E29B88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.6 142.6C201.87 142.6 202.9 141.57 202.9 140.3C202.9 139.03 201.87 138 200.6 138C199.33 138 198.3 139.03 198.3 140.3C198.3 141.57 199.33 142.6 200.6 142.6Z",
    fill: "#E29B88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188 164.5C189.27 164.5 190.3 163.47 190.3 162.2C190.3 160.93 189.27 159.9 188 159.9C186.73 159.9 185.7 160.93 185.7 162.2C185.7 163.47 186.73 164.5 188 164.5Z",
    fill: "#E29B88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.7 147.9C188.97 147.9 190 146.87 190 145.6C190 144.33 188.97 143.3 187.7 143.3C186.43 143.3 185.4 144.33 185.4 145.6C185.4 146.87 186.43 147.9 187.7 147.9Z",
    fill: "#E29B88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.8 158.9C211.07 158.9 212.1 157.87 212.1 156.6C212.1 155.33 211.07 154.3 209.8 154.3C208.53 154.3 207.5 155.33 207.5 156.6C207.5 157.87 208.53 158.9 209.8 158.9Z",
    fill: "#E29B88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199 169.9C200.27 169.9 201.3 168.87 201.3 167.6C201.3 166.33 200.27 165.3 199 165.3C197.73 165.3 196.7 166.33 196.7 167.6C196.7 168.87 197.73 169.9 199 169.9Z",
    fill: "#E29B88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.7 134.3L175 120.2L180.9 117.9L181.9 133.6L180.7 134.3Z",
    fill: "#17964A"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M261.1 148.7C262.978 148.7 264.5 147.178 264.5 145.3C264.5 143.422 262.978 141.9 261.1 141.9C259.222 141.9 257.7 143.422 257.7 145.3C257.7 147.178 259.222 148.7 261.1 148.7Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.7 276.1C252.714 276.1 258.4 270.414 258.4 263.4C258.4 256.386 252.714 250.7 245.7 250.7C238.686 250.7 233 256.386 233 263.4C233 270.414 238.686 276.1 245.7 276.1Z",
    fill: "#131A46"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M250.3 262C252.233 262 253.8 260.433 253.8 258.5C253.8 256.567 252.233 255 250.3 255C248.367 255 246.8 256.567 246.8 258.5C246.8 260.433 248.367 262 250.3 262Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_20280_301217"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 500,
    height: 500,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFruits);
export default __webpack_public_path__ + "static/media/Fruits.c5a38d8f.svg";
export { ForwardRef as ReactComponent };